import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeModule } from './pages/home/home.module';
import { CookiebotModule } from './cookiebot/cookiebot.module';

const routes: Routes = [
  { path: ':lang/home', loadChildren: () => HomeModule },
  { path: '',   redirectTo: 'en/home', pathMatch: 'full' },
  { path: ':lang/cookies', loadChildren: () => CookiebotModule },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 
  
}
